import { Dispatch } from 'redux';

import { fetchCmsApiPage } from 'modules/cms/api/cmsApiContentsEndpoints';
import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';

import {
  ClearPagesAction,
  FetchPageFailureAction,
  FetchPageRequestAction,
  FetchPageSuccessAction,
  MainStoreContentsAction,
  MainStoreContentsState,
} from './contents';
import { MainStoreErrorAction } from './error';
import { setError } from './error.actions';

const fetchPageRequest = (url: string): FetchPageRequestAction => ({
  type: 'FETCH_PAGE_REQUEST',
  url,
});

const fetchPageSuccess = (
  content: {
    content: CmsApiPage;
    type: string;
  },
  url: string,
): FetchPageSuccessAction => ({
  type: 'FETCH_PAGE_SUCCESS',
  content,
  url,
});

const fetchPageFailure = (url: string): FetchPageFailureAction => ({
  type: 'FETCH_PAGE_FAILURE',
  url,
});

export function fetchPage(pageUrl: string) {
  return (
    dispatch: Dispatch<MainStoreContentsAction | MainStoreErrorAction>,
    getState: () => { contents: MainStoreContentsState },
  ) => {
    const content = getState().contents.byUrl[pageUrl];

    if (!content) {
      dispatch(fetchPageRequest(pageUrl));
      fetchCmsApiPage(pageUrl)
        .then((fetchedPage) => {
          dispatch(
            fetchPageSuccess(
              {
                content: fetchedPage.data,
                type: fetchedPage.type,
              },
              pageUrl,
            ),
          );
        })
        .catch((e) => {
          if (e.statusCode === 404) {
            dispatch(fetchPageFailure(pageUrl));
          } else {
            dispatch(setError(e));
          }
        });
    }
  };
}

export const updatePage = fetchPageSuccess;

export function clearPages(): ClearPagesAction {
  return {
    type: 'CLEAR_PAGES',
  };
}
